var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVisibilityBlack18Dp(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 16,
    viewBox: "0 0 22 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.999 4.86328C9.34401 4.86328 7.99902 6.20827 7.99902 7.86328C7.99902 9.5183 9.34401 10.8633 10.999 10.8633C12.654 10.8633 13.999 9.5183 13.999 7.86328C13.999 6.20827 12.654 4.86328 10.999 4.86328Z",
    fill: "#858585"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11 0.363281C6 0.363281 1.73002 3.47325 0 7.86328C1.73002 12.2533 6 15.3633 11 15.3633C16.005 15.3633 20.27 12.2533 22 7.86328C20.27 3.47325 16.005 0.363281 11 0.363281ZM11 12.8633C8.24002 12.8633 6 10.6232 6 7.86323C6 5.10323 8.24002 2.86327 11 2.86327C13.76 2.86327 16 5.10328 16 7.86328C16 10.6233 13.76 12.8633 11 12.8633Z",
    fill: "#858585"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVisibilityBlack18Dp);
export default __webpack_public_path__ + "static/media/visibility-black-18dp.da332aa3b5f18a8366c9472f207fc818.svg";
export { ForwardRef as ReactComponent };